module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-2400.27fb5a2a.svg";